<template>
    <div class="hader-nav" :style="`height: ${ $getNavHeight() }px;`">
        <div class="left-div">
            <!-- 首页好友 -->
            <span v-if="leftIconName == '1'" class="iconfont" @click="toNavigation">&#xe61c;</span>
            <!-- 返回 -->
            <span v-else-if="leftIconName == '2'" class="iconfont" @click="handleBack">&#xe607;</span>
            <span v-else class="iconfont"></span>
        </div>
        <p>{{ headerTitle }}</p>
        <div class="right-div">
            <!-- 首页 -->
            <span v-if="rightIconName === '1'" class="iconfont" @click="toMsg">&#xe60e;</span>
            <!-- 下拉选择 -->
            <van-dropdown-menu style="color:#fff;right:0" v-else-if="rightIconName === '2'">
                <van-dropdown-item
                    style="right:0"
                    v-model="selectOrgId"
                    :options="orgData"
                    @change="changeOrg"
                ></van-dropdown-item>
            </van-dropdown-menu>
            <span v-else-if="rightIconName === '4'" class="iconfont iconicon-test"></span>
            <span v-else-if="rightIconName === '5'" :class="['iconfont', rightIcon]" @click="rightClickFun"></span>
            <span v-else class="iconfont"></span>
            <span class="msg-num" v-if="rightIconName === '1'&&unReadMsg>0">{{ unReadMsg }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'header-nav',
    data() {
        return {
            selectOrgId: '',
            orgData: [],
            unReadMsg: 0,
            rightIcon: '',
        };
    },
    props: {
        // 右边icon
        rightIconName: {
            type: [String, Number],
        },
        // 左边icon
        leftIconName: {
            type: [Number, String],
        },
        // 头部标题
        headerTitle: {
            type: String,
            default: '',
        },
        extr: {
            type: [Object],
        },
    },
    computed: {
    },
    created() {
        this.rightIcon = this.extr?.iconName || '';
        this.getOrg();
        this.unReadMsg = localStorage.getItem('unReadMsg');
        // 转发原生回调函数
        window.jyCallback_DidUpdateRecentSession = this.jyCallback_DidUpdateRecentSession;
    },
    methods: {
        childClick() {
            this.$emit('childByChange');
        },
        rightClickFun() {
            if (this.extr.rightCallBack) {
                this.extr.rightCallBack();
            }
        },
        handleBack() {
            if (this.extr?.leftCallBack) {
                this.extr.leftCallBack();
            } else {
                this.$router.isBack = 1;
                this.$router.go(-1);
            }
        },
        // 解析token 获取下拉组织
        async getOrg() {
            const orgType = this.$takeTokenParameters('OrgType');
            const OrgId = this.$takeTokenParameters('OrgId');
            const GroupName = this.$takeTokenParameters('GroupName');
            const OperatorId = this.$takeTokenParameters('OperatorId');
            const OperatorName = this.$takeTokenParameters('OperatorName');
            if (orgType === '1') {
                const childData = await this.getChildOrg(OrgId);
                if (childData) {
                    const orgData = [];
                    orgData.push({ value: OrgId, text: GroupName });
                    childData.map(item => {
                        const json = {};
                        json.value = item.id;
                        json.text = item.org_name;
                        orgData.push(json);
                    });
                    this.orgData = orgData;
                    this.selectOrgId = this.orgData[0].value;
                    this.$store.commit('setOrgData', this.orgData);
                }
            } else {
                this.orgData = [{ value: OperatorId, text: OperatorName }];
                this.selectOrgId = this.orgData[0].value;
                this.$store.commit('setOrgData', this.orgData);
            }
        },
        // 通过orgid获取当前组织所有子组织信息
        getChildOrg(id) {
            return this.$axios.get('/interfaceApi/basicplatform/orgtree/child/org/' + id + '/1');
        },
        changeOrg(value) {
            this.$emit('change-org', value);
        },
        // 跳转到个人中心
        toNavigation() {
            this.$callMobile('JYExternalNative', 'jyNavigationIconClick');
            // this.$callMobile('JYTeamsNative', 'jyNavigationIconClick');
        },
        // 进入消息通知界面
        toMsg() {
            this.$callMobile('JYExternalNative', 'jyNavigationChatMessageClick');
            // this.$callMobile('JYTeamsNative', 'jyNavigationChatMessageClick');
        },
        // 原生调js回传群组json
        jyCallback_DidUpdateRecentSession(data) {
            localStorage.setItem('unReadMsg', data);
            this.unReadMsg = data;
        },
    },
};

</script>
<style lang='stylus' scoped>
.van-dropdown-menu
    height 100% !important
    background #101077
    .van-dropdown-menu__item
        height 44.8rpx
        background #101077
        color #fff
.van-dropdown-menu__title
    color #fff !important
    .van-ellipsis
        color #fff
.van-popup--top
    right 0 !important

.iconfont
    font-size 20rpx
.hader-nav
    width 100%;
    background url('../../assets/images/common/title.png') top center no-repeat
    background-size: 100% 100%
    display flex
    color #ffffff
    justify-content space-between
    align-items flex-end
    font-size 20rpx
    line-height: 38rpx
    // height: 64rpx
    padding 0 15rpx
    z-index 998
    p
        flex 4
        text-align center
        font-size 18rpx
        margin: 0
        color #fff
    .left-div,.right-div
        flex 1
        .iconfont
            width 38rpx
            display: inline-block
            height: 38rpx
            line-height: 38rpx
            font-size 16rpx
    .right-div
        text-align right
        position relative
        .msg-num
            position absolute
            right -10rpx
            top -3rpx
            padding 2rpx 0
            background #E60000
            border-radius 50%
            color #fff
            text-align center
            line-height 12rpx
            font-size 10rpx
            min-width 14rpx
            min-height 14rpx
            box-sizing border-box
    .van-dropdown-menu
        height 44rpx
</style>
